import styled from 'styled-components';

import { TitleSkeleton, Utils } from '@treezor/design-system';

import { ConfigCommonSkeleton } from '@/pages/admin/configuration/ConfigCommonSkeleton';

const SkeletonContainer = styled.div`
  margin: -1rem 2rem 2.5rem 0;
`;

const ConfigContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
`;

export const SecuritySkeleton = () => (
  <SkeletonContainer>
    <ConfigCommonSkeleton />
    <ConfigContainer>
      {Utils.createEmpty(4).map((_, index) => (
        <TitleSkeleton key={index} width="32%" />
      ))}
    </ConfigContainer>
  </SkeletonContainer>
);
